import dayjs from 'dayjs';

export default function toISOTime(date) {
    return dayjs(date).format('HH:mm:ss');
}
